import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Page404 } from '@common/views/errors/404';


export default function generateHTML() {
  const div = document.createElement('div');
  ReactDOM.render(<Page404 />, div);
  return div.innerHTML;
}
